import { render, staticRenderFns } from "./BeneficiariosForm.vue?vue&type=template&id=a8b2d50c"
import script from "./BeneficiariosForm.vue?vue&type=script&lang=js"
export * from "./BeneficiariosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports